import { RetryLink } from 'apollo-link-retry';

interface ResponseError {
  statusCode: number;
  bodyText: string;
  message?: any;
}

export const retryLink = new RetryLink({
  attempts: {
    max: Infinity,
    retryIf: (error: ResponseError) => {
      if (error?.statusCode >= 500 || error?.message?.includes('Failed to fetch')) {
        return true;
      } else {
        return false;
      }
    },
  },
  delay: (count) => {
    if (count < 5) {
      return count * 300;
    } else {
      return 60000;
    }
  },
});

export const retryAnalyticsLink = new RetryLink({
  attempts: {
    max: Infinity,
    retryIf: (error: ResponseError) => {
      if (
        error?.statusCode >= 500 ||
        error?.message?.includes('Failed to fetch') ||
        error?.message?.includes('GraphQL Error')
      ) {
        return true;
      } else {
        return false;
      }
    },
  },
  delay: (count) => {
    if (count < 5) {
      return 30000;
    } else {
      return 60000;
    }
  },
});
